import React, { useEffect, useState, useContext } from 'react';
import { FooterItems } from '../Presentation/FooterItems';
import { isMobileDevice } from 'common/utilities/utils';
import { setAnalyticsData } from '../FooterUtilities/FooterUtils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { UserOrderContext } from 'context/context';
import { useSelector, useDispatch } from 'react-redux';
import OrderLookup from '../Presentation/orderLookUp';
import { clearPastOrderAction } from '@kfc-global/react-shared/redux/Actions/orderAction';
import FOOTER_CONSTANT from '../FooterConstants/FooterConstant';
import { FindAKFC } from '../../MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';

/**
 * Main Container for Entire Footer Components
 * @param - json data from content side
 */

export const Footer = props => {
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const { contentData = [], tenantReducerData, history } = props;
  const [isMobile, setMobileFooter] = useState(isMobileDevice(window.innerWidth));
  const { LANGUAGE_SELECTOR } = START_ORDER_CONSTANTS;
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { allowedLanguages = [] } = tenantReducer?.basic || {};
  const [openModal, setOpen] = useState(false);
  const { ORDER_LOOKUP_NAME, FOOTER_MENU, FIND_A_KFC } = FOOTER_CONSTANT;
  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileFooter(isMobileView);
  };
  const dispatch = useDispatch();
  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  /**
   * Method to hold user footer item click
   */
  const onFooterItemSelect = selectedFooterItem => {
    const { linkTo, name } = selectedFooterItem;
    setAnalyticsData({ footerItemSelected: name });

    if (selectedFooterItem === 'Language Selector' && allowedLanguages?.length > 1) {
      userOrderStateDispatch({ type: LANGUAGE_SELECTOR, value: { showLanguageSelector: true } });
      setTimeout(() => {
        document.getElementById('language_selector') && document.getElementById('language_selector').focus();
      }, 0);
    }
    if (name === ORDER_LOOKUP_NAME) {
      setOpen(true);
      dispatch(clearPastOrderAction({}));
    } else if (name === FOOTER_MENU && linkTo) {
      navigateToUrl(linkTo);
    } else if (linkTo) {
      if (name === FIND_A_KFC) {
        const eventName = 'findAStore';
        FindAKFC(eventName);
        return false;
      }
      navigateToUrl(linkTo);
    }
  };

  const onNavigateToHome = () => {
    history.push({
      pathname: '/',
    });
    window.scrollTo(0, 0);
  };

  const navigateToUrl = url => {
    if (url?.includes('http')) {
      window.location.replace(url);
      return;
    }
    history.push({
      pathname: url,
    });
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <div className='footer in' data-testid='FooterItems-component' role='contentinfo'>
        <FooterItems
          contentData={contentData}
          isMobile={isMobile}
          clickHandler={onFooterItemSelect}
          tenantReducerData={tenantReducerData}
          navigateHandler={onNavigateToHome}
          data-testid='footer-items'
        />
      </div>
      {openModal && (
        <OrderLookup isOpen={true} handleClose={() => setOpen(false)} tenantReducerData={tenantReducerData} />
      )}
    </div>
  );
};
export default Footer;
